export default function ArrowDown({stroke="#181818", fill="white"}) {
    return (
        <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1064_4682)">
            <path d="M12.0008 6.59943V16.0275M12.0008 16.0275L16.7148 11.3135M12.0008 16.0275L7.28675 11.3135" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
            <clipPath id="clip0_1064_4682">
            <rect width="16" height="16" fill={fill} transform="translate(23.3145 11.3135) rotate(135)"/>
            </clipPath>
            </defs>
        </svg>

    )
}